import { render, staticRenderFns } from "./ClientPhysicianOrderList.vue?vue&type=template&id=3e727d34&scoped=true&"
import script from "./ClientPhysicianOrderList.vue?vue&type=script&lang=js&"
export * from "./ClientPhysicianOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ClientPhysicianOrderList.vue?vue&type=style&index=0&id=3e727d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e727d34",
  null
  
)

export default component.exports